import { render, staticRenderFns } from "./galleryCategories.vue?vue&type=template&id=648632ac&"
import script from "./galleryCategories.vue?vue&type=script&lang=js&"
export * from "./galleryCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports